import React from 'react';
import { CheckCircle, MoneyWavy, Sparkle, Ticket } from '@phosphor-icons/react';

const card=[
  {
    icon:<div className='label-16 bg-[#FFF2F2] px-[13px] py-1.5 items-center rounded-full text-primary'>1</div>,
    content:'Forward your Ticket mail',
  },
  {
    icon:<div className='label-16 bg-[#FFF2F2] px-3 py-1.5 items-center rounded-full text-primary'>2</div>,
    content:<div>Click <span className='text-primary'>“I’ve forwarded my tickets”</span> button</div>,
  },
  {
    icon:<div className='label-16 bg-[#FFF2F2] px-3 py-1.5 items-center rounded-full text-primary'>3</div>,
    content:'Set your Price and sell quickly',
  },
]
export {card};